import Dexie, { type EntityTable } from 'dexie'
import type { Attachment, Entry, Habit, HabitCheckin, Setting } from '@/types'

export class MyDaysDB extends Dexie {
  entries!: EntityTable<Entry, 'id'>
  attachments!: EntityTable<Attachment, 'id'>
  habits!: EntityTable<Habit, 'id'>
  habitCheckins!: EntityTable<HabitCheckin, 'id'>
  settings!: EntityTable<Setting, 'key'>

  constructor(name = 'mydays-local') {
    super(name)
    this.version(1).stores({
      entries: 'id,type,occurredOn,occurredAt,createdAt,updatedAt,deletedAt',
      attachments: 'id,entryId,createdAt',
      habits: 'id,createdOn,createdAt,updatedAt,archivedAt',
      habitCheckins: 'id,habitId,occurredOn,[habitId+occurredOn],createdAt,deletedAt',
      settings: 'key,updatedAt'
    })
    this.version(2).stores({
      entries: 'id,type,occurredOn,occurredAt,[type+occurredOn],createdAt,updatedAt,deletedAt',
      attachments: 'id,entryId,createdAt',
      habits: 'id,createdOn,createdAt,updatedAt,archivedAt',
      habitCheckins: 'id,habitId,occurredOn,[habitId+occurredOn],createdAt,updatedAt,deletedAt',
      settings: 'key,updatedAt'
    }).upgrade(async (transaction) => {
      const now = new Date().toISOString()
      await transaction.table('habitCheckins').toCollection().modify((item) => {
        if (!item.updatedAt) item.updatedAt = item.createdAt || now
      })
    })
    this.version(3).stores({
      entries: 'id,type,occurredOn,occurredAt,[type+occurredOn],createdAt,updatedAt,deletedAt',
      attachments: 'id,entryId,createdAt',
      habits: 'id,createdOn,createdAt,updatedAt,archivedAt',
      habitCheckins: 'id,habitId,occurredOn,&[habitId+occurredOn],createdAt,updatedAt,deletedAt',
      settings: 'key,updatedAt'
    }).upgrade(async (transaction) => {
      const table = transaction.table<HabitCheckin>('habitCheckins')
      const items = (await table.toArray()).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
      const seen = new Set<string>()
      const duplicateIds: string[] = []
      for (const item of items) {
        const key = `${item.habitId}::${item.occurredOn}`
        if (seen.has(key)) duplicateIds.push(item.id)
        else seen.add(key)
      }
      if (duplicateIds.length) await table.bulkDelete(duplicateIds)
    })
  }
}

export const db = new MyDaysDB()
